var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_550_921",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 100,
    width: 800,
    height: 600
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 100H800V700H0V100Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_550_921)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 100V700H800V100H0Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_550_921",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 100,
    width: 800,
    height: 600
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 100V700H800V100H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_550_921)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_550_921",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 100,
    width: 800,
    height: 600
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 100H800V700H0V100Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_550_921)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-89.0752 657.126L86.9748 731.601L803.975 180.951L896.85 70.3008L708.6 45.4258L416.15 282.701L180.75 442.601L-89.0752 657.126Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-65 709.3L24.725 752.5L863.5 60.0254H737.575L-64.975 709.275L-65 709.3Z",
    fill: "#F50100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M889.075 657.126L713.025 731.601L-3.97509 180.951L-96.8501 70.3008L91.3999 45.4258L383.85 282.701L619.25 442.601L889.075 657.126Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M883.075 694.576L793.375 737.776L436.225 441.276L330.325 408.176L-105.8 70.6758H20.15L456 400.176L571.775 439.876L883.075 694.576Z",
    fill: "#F50100"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_550_921",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -50,
    y: 50,
    width: 901,
    height: 700
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.45 50H305.55V300H-49.3V500H305.55V750H494.45V500H850.7V300H494.45V50Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_550_921)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.45 50H305.55V300H-49.3V500H305.55V750H494.45V500H850.7V300H494.45V50Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.55 50V0H255.55V50H305.55ZM494.45 50H544.45V0H494.45V50ZM305.55 300V350H355.55V300H305.55ZM-49.3001 300V250H-99.3V300H-49.3001ZM-49.3001 500H-99.3V550H-49.3001V500ZM305.55 500H355.55V450H305.55V500ZM305.55 750H255.55V800H305.55V750ZM494.45 750V800H544.45V750H494.45ZM494.45 500V450H444.45V500H494.45ZM850.7 500V550H900.7V500H850.7ZM850.7 300H900.7V250H850.7V300ZM494.45 300H444.45V350H494.45V300ZM305.55 100H494.45V0H305.55V100ZM355.55 300V50H255.55V300H355.55ZM-49.3001 350H305.55V250H-49.3001V350ZM0.699951 500V300H-99.3V500H0.699951ZM305.55 450H-49.3001V550H305.55V450ZM355.55 750V500H255.55V750H355.55ZM494.45 700H305.55V800H494.45V700ZM444.45 500V750H544.45V500H444.45ZM850.7 450H494.45V550H850.7V450ZM800.7 300V500H900.7V300H800.7ZM494.45 350H850.7V250H494.45V350ZM444.45 50V300H544.45V50H444.45Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.3ee1a58d.svg";
export { ForwardRef as ReactComponent };